import { LayerSpecification } from "maplibre-gl";
import { CAMERA_LAYER, CAMERA_LAYER_2 } from "./definitions/camera-definition";
import {
	OTHER_ROAD_LINE,
	OTHER_ROAD_LINE_ALT,
	CLOSED_ROAD_LINE,
	ACCIDENT_ROAD_LINE,
	CLOSED_ROAD_LINE_ALT,
	CLOSED_ROAD_POINT,
	ACCIDENT_ROAD_POINT,
	OTHER_ROAD_POINT,
	OTHER_ROAD_POINT_ALT,
	CLOSED_ROAD_POINT_ALT,
	ROAD_POINT_ORANGE,
	ROAD_POINT_BLACK,
	ROAD_LINE_BLACK,
	ROAD_LINE_ORANGE,
	ROAD_POINT_BLUE_ALT,
	ROAD_LINE_BLUE_ALT,
	ROAD_POINT_CLOSED,
} from "./definitions/event-definition";
import { EVENT_DETOUR_LINE, EVENT_DETOUR_ARROWS, EVENT_DETOUR_LINE_ALT, EVENT_DETOUR_ARROWS_ALT } from "./definitions/event-detour";
import { LAU_POINT } from "./definitions/lau-definition";
import { ROAD_LAYER, POLY_LAYER } from "./definitions/uvis-definition";


/* PRESETS FOR THE PUBLIC MAP. LAST = HIGHEST DRAW ORDER */

export const winterPreset = [
	{
		id: "osm-layer",
		type: "raster",
		source: "osm",
		minzoom: 0,
		maxzoom: 19,
	} as LayerSpecification,
	ROAD_LAYER,
	EVENT_DETOUR_LINE,
	EVENT_DETOUR_ARROWS,
	OTHER_ROAD_LINE,
	OTHER_ROAD_LINE_ALT,
	POLY_LAYER,
	CLOSED_ROAD_LINE,
	ACCIDENT_ROAD_LINE,
	CLOSED_ROAD_LINE_ALT,
	CAMERA_LAYER,
	CAMERA_LAYER_2,
	LAU_POINT,
	CLOSED_ROAD_POINT,
	ACCIDENT_ROAD_POINT,
	OTHER_ROAD_POINT,
	OTHER_ROAD_POINT_ALT,
	CLOSED_ROAD_POINT_ALT,
];

export const summerPreset = [
	{
		id: "osm-layer",
		type: "raster",
		source: "osm",
		minzoom: 0,
		maxzoom: 19,
	} as LayerSpecification,
	EVENT_DETOUR_LINE,
	EVENT_DETOUR_ARROWS,
	OTHER_ROAD_LINE,
	OTHER_ROAD_LINE_ALT,
	CLOSED_ROAD_LINE,
	ACCIDENT_ROAD_LINE,
	CLOSED_ROAD_LINE_ALT,
	EVENT_DETOUR_LINE_ALT,
	EVENT_DETOUR_ARROWS_ALT,
	ROAD_LINE_BLACK,
	ROAD_LINE_ORANGE,
	ROAD_LINE_BLUE_ALT,
	CAMERA_LAYER,
	CAMERA_LAYER_2,
	ACCIDENT_ROAD_POINT,
	OTHER_ROAD_POINT,
	OTHER_ROAD_POINT_ALT,
	LAU_POINT,
	ROAD_POINT_ORANGE,
	ROAD_POINT_BLUE_ALT,
	ROAD_POINT_BLACK,
	CLOSED_ROAD_POINT,
	CLOSED_ROAD_POINT_ALT,
	ROAD_POINT_CLOSED,
];
